import { getAllBookingMeetingTypes } from '../services/getAllBookingMeetingTypes';
import type GetBookingServicesResponseMessage from 'owa-service/lib/contract/GetBookingServicesResponseMessage';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import getBookingBusiness from 'bookings-shared/lib/c1/services/getBookingBusiness';
import type FeatureSource from 'bookings-shared/lib/c1/constants/source';

// We need this function for entrypoints outside of a person's booking page
// as we cannot access the store without already opening the user's personal booking page
// If someone is a first time user, the getBookingMeetingType is going to return an array of length 0
export default async function getFirstTimeUserCheck() {
    let newUser = false;
    if (isFeatureEnabled('bookwithme-c1B2Migration')) {
        const bookingsSMTPAddress = getUserConfiguration().SessionSettings?.UserPrincipalName || '';
        const response = await getBookingBusiness(bookingsSMTPAddress, 'BookWithMe');

        /**
         * In B2, for first time user businessInfo is not there in getBookingBusiness response
         * because list services will return an array of length 0 for the case when all services are deleted
         */
        if (!response.hasError && !response.businessInfo) {
            newUser = true;
        }
    } else {
        await getAllBookingMeetingTypes().then(
            (result: GetBookingServicesResponseMessage | null) => {
                if (result === null || result.Services?.length === 0) {
                    newUser = true;
                }
            }
        );
    }
    return newUser;
}
